import { render, staticRenderFns } from "./AvailableCollectionsDropdown.vue?vue&type=template&id=aed719c0&scoped=true"
import script from "./AvailableCollectionsDropdown.vue?vue&type=script&lang=js"
export * from "./AvailableCollectionsDropdown.vue?vue&type=script&lang=js"
import style0 from "./AvailableCollectionsDropdown.vue?vue&type=style&index=0&id=aed719c0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed719c0",
  null
  
)

export default component.exports